import { create } from 'zustand'

interface ModalState {
   isAdvanceTargetingCampaignModalOpen: boolean
   openAdvanceTargetingCampaignModal: () => void
   closeAdvanceTargetingCampaignModal: () => void
}

export const useAdvanceTargetingCampaignModalStore = create<ModalState>(
   (set) => ({
      isAdvanceTargetingCampaignModalOpen: false,
      openAdvanceTargetingCampaignModal: () =>
         set({ isAdvanceTargetingCampaignModalOpen: true }),
      closeAdvanceTargetingCampaignModal: () =>
         set({ isAdvanceTargetingCampaignModalOpen: false }),
   })
)
